class RAMQCurrentUser {
    public CElogin: string;
    public AIPu: string;
}

export { RAMQCurrentUser };
